import {ValidRegionCode} from 'src/config';

/**
 * Stores that currently have the blue & gray Stryd 5.0 clip pack in stock.
 * Global, US, UK, and Japan are hidden until stock returns.
 */
const CLIPS_AVAILABLE_REGIONS = new Set<ValidRegionCode>(['au', 'ca', 'eu']);

/** List-price pack and the discounted add-on sold from the store checkbox. */
const STRYD5_CLIPS_PRODUCT_SLUGS = new Set([
  'clip-pack-stryd-5-0',
  'clip-pack-stryd-5-0-add-on',
]);

export const isStryd5ClipsAddOnAvailable = (region: ValidRegionCode): boolean =>
  CLIPS_AVAILABLE_REGIONS.has(region);

export const isStryd5ClipsProductSlug = (slug: string): boolean =>
  STRYD5_CLIPS_PRODUCT_SLUGS.has(slug);
